import {chatsCache} from '@components/right-panel/task-chat-list/ensure-cache-initialized'

export type FilterChatListType = (ent: {
  chatType: 'task' | 'group' | 'user'
}) => boolean

class ApiChatList {
  public filterChatList?: FilterChatListType = undefined
  public areDefaultFiltersDisabled?: boolean = false

  public triggerChatList?: () => void = undefined
  public setAreDefaultFiltersDisabled?: (disabled: boolean) => void = (
    value: boolean
  ) => {
    this.areDefaultFiltersDisabled = value
    chatsCache.clear()
  }
}

export const apiChatList = new ApiChatList()
